<template>
  <div>
    <header>
      <h3>优惠券</h3>
    </header>
    <el-form style="width: 800px" label-width="100px" class="demo-ruleForm">
      <h4 class="title">企业选择</h4>
      <el-form-item label="请选择企业" required>
        <el-select
          v-model="selectValue1"
          multiple
          placeholder="请选择"
          @change="secectFn1()"
          style="width: 300px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.name"
            :value="item.companyId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <h4 class="title">券基本设置</h4>
      <el-form-item label="选择店铺" required>
        <el-select
          v-model="selectValue2"
          @change="secectFn2()"
          placeholder="请选择店铺"
        >
          <el-option
            v-for="item in mchList"
            :key="item.value"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消费券名称" required>
        <el-input v-model="name" style="width: 300px"></el-input>
      </el-form-item>
      <el-form-item label="优惠信息" required>
        <div style="display: flex">
          优惠<el-input
            style="width: 80px"
            v-model="money"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
          ></el-input
          >元
        </div>
      </el-form-item>
      <el-form-item label="券有效期" required="">
        <el-date-picker
          v-model="date1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="优惠方式" prop="resource">
        <el-radio-group v-model="radio">
          <el-radio :label="1">消费券</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >立即<span v-if="type == 1">创建</span
          ><span v-if="type == 2">修改</span></el-button
        >
        <el-button @click="goBack()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getCoupon, getMch, addCoupon } from "@/api/active/coupon";
import { getCompanyList } from "@/api/finance";
export default {
  data() {
    return {
      selectValue1: [], //选择发放公司id列表
      selectValue2: "", //绑定商家id
      options: [], //
      selectProps: { multiple: true, label: "name", value: "companyId" },
      mchList: [],
      name: "", //优惠券名
      money: "", //优惠券价格
      date1: null, //优惠券时间
      radio: 1, //券类型
      id: false,
      type: 1,
    };
  },
  mounted() {
    this.getCompany();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.type = 2;
    } else {
      this.type = 1;
    }
  },
  methods: {
    //初始化获取数据
    getCompany() {
      getCompanyList().then((res) => {
        this.options = res.data;
      });
      getMch().then((res) => {
        this.mchList = res.data;
      });
    },

    // 添加提交
    submitForm(formName) {
      if (this.selectValue1.length == 0) {
        this.$message({
          message: "请选择至少一个发放企业",
          type: "warning",
        });
      } else if (this.selectValue2 == "") {
        this.$message({
          message: "请选择店铺",
          type: "warning",
        });
      } else if (this.name == "") {
        this.$message({
          message: "请填优惠券名",
          type: "warning",
        });
      } else if (this.money == "") {
        this.$message({
          message: "请填优惠券价格",
          type: "warning",
        });
      } else if (this.date1 == null) {
        this.$message({
          message: "请填写优惠券有效期",
          type: "warning",
        });
      } else {
        let data = {
          amount: this.money,
          companyNames: this.name,
          etime: 1606198234061,
          mchId: this.selectValue2,
          mchName: "",
          name: this.name,
          companyIds: "",
          stime: 1606198234061,
          type: this.radio,
          companyNames: "",
        };
        this.options.forEach((item) => {
          for (let i = 0; i <= this.selectValue1.length; i++) {
            if (item.companyId == this.selectValue1[i]) {
              data.companyNames += item.name + ",";
              data.companyIds += item.companyId + ",";
            }
          }
        });
        data.companyNames = data.companyNames.substr(
          0,
          data.companyNames.length - 1
        );
        data.companyIds = data.companyIds.substr(0, data.companyIds.length - 1);
        this.mchList.forEach((item) => {
          if (item.id == this.selectValue2) {
            data.mchName = item.name;
          }
        });
        // if (this.type == 2) {
        //   data.id = this.id;
        // }
        data.stime = this.date1[0].getTime();
        data.etime = this.date1[1].getTime() - 1 + 24 * 60 * 60 * 1000;
        console.log(data);
        addCoupon(data).then((res) => {
          this.$router.go(-1);
          // if (this.type == 1) {
            this.$message({
              message: "创建成功",
              type: "success",
            });
          // } else {
          //   this.$message({
          //     message: "修改成功",
          //     type: "success",
          //   });
          // }
        });
      }
    },
    secectFn1() {},
    secectFn2() {
      console.log(this.selectValue2);
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
}
.el-form-item {
  margin: 50upx 0;
}
.title {
  margin: 30px 0 20px 0;
}
.btn {
  width: 80px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesPromotion/addCoupon.vue